import type { DropdownItemContext } from '~/components/ui/dropdown-item.vue'
import { ProductPlatforms, type ProductPlatformKeys } from '~/server/type'
import type { BenefitGroupedData, ListContext, TravelDataContext } from '~/stores/products/types'
import type { IRequestResponse } from '~/types'

export const useContentApis = () => {
	type queryType = {
		code_name?: string | number
		category: string
		user_type?: ProductPlatformKeys
		provider?: string
		group_id?: string
	}
	const getBenefits = async <T = BenefitGroupedData | TravelDataContext | []>(query: queryType) => {
		const result = await $fetch<IRequestResponse<T>>('/api/bff/v1/benefits', {
			query: { ...query, user_type: query.user_type || ProductPlatforms.BUSINESS }
		})
		return toRef(result)
	}
	const getNeedToKnow = async (query: queryType) => {
		const result = await $fetch<IRequestResponse<ListContext[string]>>('/api/bff/v1/product-need-to-know', {
			query: { ...query, user_type: query.user_type || ProductPlatforms.BUSINESS }
		})
		return result
	}
	const getClaimProcess = async (query: queryType) => {
		const result = await $fetch<IRequestResponse<ListContext[string]>>('/api/bff/v1/claim-process', {
			query: { ...query, user_type: query.user_type || ProductPlatforms.BUSINESS }
		})
		return result
	}
	const getHospitalGuide = async (query: queryType) => {
		const result = await $fetch<IRequestResponse<ListContext[string]>>('/api/bff/v1/hospital-access-guide', {
			query: { ...query, user_type: query.user_type || ProductPlatforms.BUSINESS }
		})
		return result
	}
	const getExclusions = async (query: queryType) => {
		const result = await $fetch<IRequestResponse<DropdownItemContext>>('/api/bff/v1/exclusions', {
			query: { ...query, user_type: query.user_type || ProductPlatforms.BUSINESS }
		})
		return result
	}
	const getGuides = async (query: queryType) => {
		const result = await $fetch<IRequestResponse<ListContext[string]>>('/api/bff/v1/how-it-works', {
			query: { ...query, user_type: query.user_type || ProductPlatforms.BUSINESS }
		})
		return result
	}
	const getProductInformation = async (query: queryType) => {
		const result = await $fetch<IRequestResponse<ListContext | Record<string, DropdownItemContext>>>(
			'/api/bff/v1/product-information',
			{
				query: { ...query, user_type: query.user_type || ProductPlatforms.BUSINESS }
			}
		)
		return result
	}

	return {
		getBenefits,
		getNeedToKnow,
		getClaimProcess,
		getHospitalGuide,
		getExclusions,
		getGuides,
		getProductInformation
	}
}
